import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Panel } from 'primereact/panel'
import { ProgressBar } from 'primereact/progressbar'

import {
  Btn,
  CustomDropdown,
  CustomMultiSelect,
  InputText,
  PageHeader,
  Periodo,
  TextBtn,
} from '../../../../components'
import Badge from '../../../../components/Badge/Badge'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { PickingStatus } from '../../../../constants/picking-status'
import useAcompanhamentoPicking, { LOAD_MESSAGE } from './AcompanhamentoPickingHook'
import './AcompanhamentoPicking.css'

function AcompanhamentoPicking({ dispatch, history, selectedTp }) {
  const { state, localDispatch, ORDENAR_OPTIONS } = useAcompanhamentoPicking(selectedTp)

  // Extrai lista única de empresas dos pickings
  const empresasOptions = React.useMemo(() => {
    const empresasSet = new Set()
    ;((state.dados && state.dados.pickings) || []).forEach(p => {
      if (p.company_name) empresasSet.add(p.company_name)
    })
    return Array.from(empresasSet)
      .sort()
      .map(c => ({ label: c, value: c }))
  }, [state.dados])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.FETCHING_DATA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Para o auto refresh quando sair da tela
  useEffect(() => {
    return () => {
      localDispatch.stopAutoRefresh()
    }
  }, [])

  const temDados = state.dados !== null

  return (
    <>
      <PageHeader>1.8 - Acompanhamento Picking</PageHeader>
      <div style={{ marginTop: 16, minHeight: '80vh' }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div style={{ marginBottom: 5, color: '#14B0BF' }}>Data Criação do Picking:</div>
          <div className="p-grid p-align-center">
            <div className="p-col-12 p-lg-6">
              <Periodo
                periodoInicial={state.pInicial}
                periodoFinal={state.pFinal}
                onPesquisar={(pInicial, pFinal) => localDispatch.onBtnPesquisar(pInicial, pFinal)}
                onChangePeriodoInicial={localDispatch.onPeriodoInicialChange}
                onChangePeriodoFinal={localDispatch.onPeriodoFinalChange}
              />
            </div>
          </div>

          {temDados && (
            <>
              {/* Card STATUS */}
              <div className="acomp-picking__secao-status">
                <div className="acomp-picking__status-titulo">STATUS</div>
                <div className="acomp-picking__status-items">
                  <div className="acomp-picking__status-item">
                    <div
                      className="acomp-picking__status-valor"
                      style={{ color: PickingStatus.ComEntregasAssociadas.color }}
                    >
                      {state.dados.status.com_entregas_associadas}
                    </div>
                    <div className="acomp-picking__status-label">COM ENTREGAS ASSOCIADAS</div>
                  </div>
                  <div className="acomp-picking__status-item">
                    <div
                      className="acomp-picking__status-valor"
                      style={{ color: PickingStatus.ProntoParaDownload.color }}
                    >
                      {state.dados.status.pronto_para_download}
                    </div>
                    <div className="acomp-picking__status-label">PRONTO PARA DOWNLOAD</div>
                  </div>
                  <div className="acomp-picking__status-item">
                    <div
                      className="acomp-picking__status-valor"
                      style={{ color: PickingStatus.PickingConcluido.color }}
                    >
                      {state.dados.status.concluido}
                    </div>
                    <div className="acomp-picking__status-label">CONCLUÍDO</div>
                  </div>
                  <div className="acomp-picking__status-item">
                    <div
                      className="acomp-picking__status-valor"
                      style={{ color: PickingStatus.ResumoEmitido.color }}
                    >
                      {state.dados.status.resumo_emitido}
                    </div>
                    <div className="acomp-picking__status-label">RESUMO EMITIDO</div>
                  </div>
                </div>
              </div>

              {/* Card PROGRESSO */}
              <div className="acomp-picking__secao-progresso">
                <div className="acomp-picking__progresso-titulo">PROGRESSO</div>
                <div className="acomp-picking__progresso-items">
                  <div className="acomp-picking__progresso-item">
                    <div className="acomp-picking__progresso-valor">
                      {state.dados.progresso.total_pickings}
                    </div>
                    <div className="acomp-picking__progresso-label">TOTAL PICKINGS</div>
                  </div>
                  <div className="acomp-picking__progresso-item">
                    <div className="acomp-picking__progresso-valor">
                      {state.dados.progresso.pickings_finalizados}
                    </div>
                    <div className="acomp-picking__progresso-label">PICKINGS FINALIZADOS</div>
                  </div>
                </div>
              </div>

              {/* Filtros */}
              <div className="p-grid p-align-center" style={{ marginTop: 20 }}>
                <div className="p-col-12 p-lg-4">
                  <InputText
                    label="Pesquisar:"
                    value={state.searchText}
                    onChange={value => localDispatch.onSearchTextChange(value)}
                    placeholder="ID, nome, empresa, data ou status..."
                  />
                </div>
                <div className="p-col-12 p-lg-4">
                  <CustomDropdown
                    showLabel={true}
                    label="Ordenar Por:"
                    optionLabel="label"
                    options={ORDENAR_OPTIONS}
                    value={state.ordenarPor}
                    onChange={value => localDispatch.onOrdenarPorChange(value)}
                    placeholder="Selecione..."
                  />
                </div>
                <div
                  className="p-col-12 p-lg-4"
                  style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}
                >
                  <div style={{ flex: 1 }}>
                    <CustomMultiSelect
                      label="Empresas"
                      optionLabel="label"
                      options={empresasOptions}
                      value={state.empresasSelecionadas}
                      onChange={value => localDispatch.onEmpresasSelecionadasChange(value)}
                      filterPlaceholder="Buscar empresa..."
                    />
                  </div>
                  <Btn onClick={() => localDispatch.onLimparFiltros()}>Limpar Filtros</Btn>
                </div>
              </div>

              {/* Label Pickings em Andamento */}
              <div className="acomp-picking__andamento-label">PICKINGS EM ANDAMENTO</div>

              {/* Cards dos Pickings */}
              <div className="acomp-picking__cards-container">
                {state.pickingsFiltrados.map(picking => (
                  <PickingCard
                    key={picking.id}
                    picking={picking}
                    onClick={() =>
                      history.push('/main/picking/historico-leitura', { pickingId: picking.id })
                    }
                  />
                ))}
                {state.pickingsFiltrados.length === 0 && (
                  <div className="acomp-picking__empty-message">
                    Nenhum picking em andamento encontrado para os filtros aplicados
                  </div>
                )}
              </div>
            </>
          )}
        </Panel>
      </div>
    </>
  )
}

// Card individual do Picking
function PickingCard({ picking, onClick }) {
  const percent = getPercentualSeparacaoValue(picking.percentual_separacao)
  const percentLabel = formatPercentualSeparacao(picking.percentual_separacao)
  const progressBarClassName =
    percent >= 100
      ? 'acomp-picking__progressbar acomp-picking__progressbar--complete'
      : 'acomp-picking__progressbar acomp-picking__progressbar--in-progress'
  const cardClassName =
    picking.style === 'Reconferencia'
      ? 'acomp-picking__card acomp-picking__card--reconferencia'
      : 'acomp-picking__card'

  const statusInfo = getStatusInfo(picking.status)

  return (
    <div className={cardClassName} onClick={onClick}>
      {/* Coluna esquerda: info */}
      <div className="acomp-picking__card-info">
        <div className="acomp-picking__card-id">Código: {picking.id}</div>
        <div className="acomp-picking__card-nome">{picking.name}</div>
        <div className="acomp-picking__card-empresa">{picking.company_name}</div>
        <div className="acomp-picking__card-data">Criado em: {picking.created_at}</div>
      </div>

      {/* Coluna meio: progresso separação */}
      <div className="acomp-picking__card-progress">
        <span className="acomp-picking__progress-label">% Separação</span>
        <div className="acomp-picking__progress-bar-container">
          <ProgressBar
            className={progressBarClassName}
            value={percent}
            showValue={false}
            style={{ height: '20px', backgroundColor: '#e0e0e0' }}
          />
          <span className="acomp-picking__progress-value">{percentLabel}%</span>
        </div>
      </div>

      {/* Coluna direita: badge + bips */}
      <div className="acomp-picking__card-bips">
        <div style={{ marginBottom: 6 }}>
          <Badge color={statusInfo.color}>{statusInfo.label}</Badge>
        </div>
        <div className="acomp-picking__bip-item">
          <div className="acomp-picking__bip-label">1º Bip</div>
          <div className="acomp-picking__bip-valor">{picking.primeiro_bip || 'Não iniciado'}</div>
        </div>
        <div className="acomp-picking__bip-item">
          <div className="acomp-picking__bip-label">Último Bip</div>
          <div className="acomp-picking__bip-valor">{picking.ultimo_bip || 'Não iniciado'}</div>
        </div>
      </div>
    </div>
  )
}

function getPercentualSeparacaoValue(percentualSeparacao) {
  const percent = Number(percentualSeparacao)
  return Number.isFinite(percent) ? percent : 0
}

function formatPercentualSeparacao(percentualSeparacao) {
  if (
    percentualSeparacao === null ||
    percentualSeparacao === undefined ||
    percentualSeparacao === ''
  ) {
    return '0'
  }

  return String(percentualSeparacao)
}

function getStatusInfo(status) {
  switch (status) {
    case 'Com Entregas Associadas':
      return PickingStatus.ComEntregasAssociadas
    case 'Pronto Para Download':
      return PickingStatus.ProntoParaDownload
    case 'Picking Concluido':
      return PickingStatus.PickingConcluido
    case 'Resumo Emitido':
      return PickingStatus.ResumoEmitido
    case 'Sem Entregas Associadas':
      return PickingStatus.SemEntregasAssociadas
    default:
      return { label: status, color: '#999' }
  }
}

const mapStateToProps = state => ({
  selectedTp: state.system.selectedTp,
})

export default connect(mapStateToProps)(withRouter(AcompanhamentoPicking))
